import React from 'react'
import { useTranslation } from 'react-i18next'

const Error404 = () => {
  const { t } = useTranslation();

  return (
    <main className='site-width'>
      <div className='error-404'>
        <h1>{t('estados.error404Titulo')}</h1>
        <p>{t('estados.error404Texto')}</p>
        <a href='/'>{t('estados.error404Volver')}</a>
      </div>
    </main>
  )
}

export default Error404
